module.exports = __webpack_public_path__ + "static/media/kehu-al1.c9523872.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageIntelligentDataSecurityGateway/kehu-al1.png
// module id = 630
// module chunks = 0